import {HiOutlineCursorClick} from "react-icons/hi";
import Link from "next/link";

const cartNoTown = ()=>{
    return <div className="cartEmpty marginBottom">
        <div>
            <HiOutlineCursorClick/>
            <h1 className="title">Selecciona una ciudad de Envío</h1>
            <p className="cartDescription">Asegurate de tener un arreglo floral en tu carrito para poder hacer tu envío.</p>
            <p className="cartDescription">Para poder continuar, regresa al detalle del producto(<u>chocolates, globos, etc no aplica</u>), selecciona un fecha y ciudad de envío.</p>
            <p>Si crees que es un error
                <Link href='/contacto'>
                    <a> contactanos.</a>
                </Link></p>
            <img className="cartEmptyImage" src="https://images.ctfassets.net/ky6xvjc0lt5e/2aRN6pUjuYXNN3uF3MLlDo/c6b947320cf087357e96675d7118d5a6/ezgif.com-gif-maker.gif" alt="Selecciona una ciudad"/>
        </div>
    </div>
}


export default cartNoTown;
